// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2LDZw","insightsList":"newBusinessInsightsMenu_insightsList__2yXPI","active":"newBusinessInsightsMenu_active__1MUHj"};